/**
 * Aligns the mega-menu dropdown content with the LEFT EDGE OF THE NAV MENU
 * (not the page/logo edge). The nav's left position depends on the logo width,
 * so it can't be a fixed value — we measure it and expose it as the CSS custom
 * property `--mega-menu-inline-start`, consumed by .menu-list__submenu-inner.
 *
 * Recomputed on load, resize, and when the logo image finishes loading (its
 * width shifts where the nav starts). Desktop menu only.
 */
(function () {
  const header = document.querySelector('#header-component');
  if (!header) return;

  function align() {
    // Desktop mega-menu only; the mobile drawer doesn't use this.
    if (window.matchMedia('(max-width: 749px)').matches) {
      header.style.removeProperty('--mega-menu-inline-start');
      return;
    }

    const list = header.querySelector('.menu-list__list, .menu-list');
    const inner = header.querySelector('.menu-list__submenu-inner');
    if (!list || !inner) return;

    const navLeft = list.getBoundingClientRect().left;

    // Measure the inner's border-left with no start padding, then set padding
    // so the content begins exactly at the nav's left edge.
    const prev = inner.style.paddingInlineStart;
    inner.style.paddingInlineStart = '0px';
    const innerLeft = inner.getBoundingClientRect().left;
    inner.style.paddingInlineStart = prev;

    const offset = Math.max(0, Math.round(navLeft - innerLeft));
    header.style.setProperty('--mega-menu-inline-start', offset + 'px');
  }

  function init() {
    align();
    window.addEventListener('resize', align);
    window.addEventListener('load', align);
    // Logo image may load after DOMContentLoaded and shift the nav start.
    const logo = header.querySelector('img');
    if (logo && !logo.complete) logo.addEventListener('load', align, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
